import { useEffect, useState } from 'react';

/**
 * Ticks a `Date.now()` snapshot every `intervalMs` — for a live "updated N s
 * ago" style label. No existing hook in the codebase provided this (checked
 * `ui/core/hooks` and the rest of `apps/clients/web/src`): other relative-time
 * spots (e.g. `search/card_filters.ts`) compute a label once from a `now`
 * passed in by the caller, they don't drive their own re-render.
 */
export function useNow(intervalMs: number): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => {
      setNow(Date.now());
    }, intervalMs);
    return () => {
      clearInterval(id);
    };
  }, [intervalMs]);

  return now;
}
